import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import WhatWeStorePage from '@/v2/components/pages/public-pages/what-we-store-page'
import { faqSectionContent, metaImages, ogImages } from '@/v2/constants/pages/public-pages/what-we-store-page'

interface WhatWeStorePageProps {}

const Page: React.FC<WhatWeStorePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.what_we_store.title ?? ''}
        keywords={META_CONTENTS.what_we_store?.keywords ?? ''}
        description={META_CONTENTS.what_we_store?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        searchImages={metaImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />

      <WhatWeStorePage />
    </>
  )
}

export default Page
